import { userFullName } from "helpers/common";
import { Col, Row } from "react-bootstrap";

const GuardianDetailRow = ({ index, guardian, slug }) => {
  const title = slug === "teacher" ? "Teacher" : slug === "parent" ? "Parent" : "--";
  return (
    <>
      <Row className="px-2">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              {title} {index + 1}
            </h6>
          </div>
        </Col>
      </Row>
      <Row key={index} className="border-bottom p-2 pt-0">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Last Name:
            </h6>
            <p className="m-0 themeBlue">
              {guardian?.client_guardian?.lastname}
            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              First Name:
            </h6>
            <p className="m-0 themeBlue">
              {guardian?.client_guardian?.firstname}

            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Email:
            </h6>
            <p className="m-0 themeBlue">
              {
                guardian?.client_guardian
                  ?.email
              }
            </p>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default GuardianDetailRow;